import {
  AppBar,
  Backdrop,
  Fade,
  Grid,
  makeStyles,
  Modal,
  Tab,
  Tabs,
  Theme,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { RiCloseLine } from 'react-icons/ri';
import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';
import ColorsService from '../../../../services/ColorsService';
import SizesService from '../../../../services/SizesService';
import {
  DeleteTamanhoButton,
  Header,
  NewTamanhoButton,
  TamanhoInput,
  TamanhoInputColor,
  TamanhoItem,
} from '../../../Produtos/components/Drawers/drawer_styles';
import { StatusSaleButton } from '../../../Produtos/components/styles';
import TabPanel from '../TabPanel';
import {
  ButtonStyled,
  InformativeSpan,
  ModalWrapper,
  PageTitle,
  Wrapper,
} from './styles';
import styleMaterial from './styles/styleMaterial';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    paddingTop: 10,
  },
}));

const Grade: React.FC = () => {
  const { subTab } = useParams() as any;

  const classes = styleMaterial();
  const classes_root = useStyles();

  const { addToast } = useToast();
  const { user } = useAuth();

  const [tab, setTab] = useState(() => {
    if (!Number.isNaN(subTab)) {
      const subTabValue = Number(subTab);

      if (subTabValue >= 0 && subTabValue <= 1) {
        return subTabValue;
      }

      return 0;
    }

    return 0;
  });
  const [selectedTamanho, setSelectedTamanho] = useState<any>();
  const [selectedCor, setSelectedCor] = useState<any>();
  const [tamanhos, setTamanhos] = useState<any[]>([]);
  const [cores, setCores] = useState<any[]>([]);

  useEffect(() => {
    async function loadSizes(): Promise<void> {
      try {
        let sizes = await SizesService.listSizes(user.empresa_id, 2);

        if (sizes.length === 0) {
          sizes = await SizesService.generate(user.empresa_id, 2);
        }

        setTamanhos(
          sizes.map((size) => ({
            id: size.id,
            name: size.name,
            order: size.order,
            active: size.active,
          })),
        );
      } catch (error) {
        addToast({
          title: 'Algo deu errado.',
          type: 'error',
          description:
            (error as any).response?.data?.message ||
            'Erro ao carregar os tamanhos',
        });
      }
    }

    async function loadColors(): Promise<void> {
      try {
        let colors = await ColorsService.listColors(user.empresa_id);

        if (colors.length === 0) {
          colors = await ColorsService.generateColors(user.empresa_id);
        }

        setCores(
          colors.map((size) => ({
            id: size.id,
            name: size.name,
            hex: size.hex,
            order: size.order,
            active: size.active,
          })),
        );
      } catch (error) {
        addToast({
          title: 'Algo deu errado.',
          type: 'error',
          description:
            (error as any).response?.data?.message ||
            'Erro ao carregar as cores',
        });
      }
    }

    loadSizes();
    loadColors();
  }, [user.empresa_id, addToast]);

  const handleCreateSize = useCallback(async () => {
    addToast({
      title: 'Seu tamanho está sendo criado.',
      type: 'info',
    });

    try {
      const size = await SizesService.createSize(user.empresa_id, {
        name: '',
        type: 2,
        order: tamanhos[tamanhos.length - 1]?.order || 1,
        code: null,
        active: true,
        companyId: user.empresa_id,
      });

      setTamanhos((oldState) => [
        ...oldState,
        {
          id: size.id,
          name: size.name,
          order: size.order,
          active: size.active,
          code: size.code,
        },
      ]);

      addToast({
        title: 'Tamanho criado com sucesso.',
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado.',
        type: 'error',
        description:
          (err as any).response?.data?.message || 'Erro ao criar o tamanho',
      });
    }
  }, [user.empresa_id, tamanhos, addToast]);

  const handleCreateColor = useCallback(async () => {
    addToast({
      title: 'Sua cor está sendo criada.',
      type: 'info',
    });

    try {
      const color = await ColorsService.createColor(user.empresa_id, {
        name: '',
        order: cores[cores.length - 1]?.order || 1,
        hex: '#ff0000',
        active: true,
        companyId: user.empresa_id,
      });

      setCores((oldState) => [
        ...oldState,
        {
          id: color.id,
          name: color.name,
          order: color.order,
          active: color.active,
          hex: color.hex,
        },
      ]);

      addToast({
        title: 'Cor criada com sucesso.',
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado.',
        type: 'error',
        description:
          (err as any).response?.data?.message || 'Erro ao criar a cor',
      });
    }
  }, [user.empresa_id, cores, addToast]);

  const handleSetTamanhoValue = useCallback(
    (id: number, field: string, value: any) => {
      setTamanhos((oldState) =>
        oldState.map((tamanho) => {
          if (String(tamanho.id) === String(id)) {
            return {
              ...tamanho,
              [field]: value,
            };
          }

          return tamanho;
        }),
      );
    },
    [],
  );

  const handleSetCorValue = useCallback(
    (id: number, field: string, value: any) => {
      setCores((oldState) =>
        oldState.map((cor) => {
          if (String(cor.id) === String(id)) {
            return {
              ...cor,
              [field]: value,
            };
          }

          return cor;
        }),
      );
    },
    [],
  );

  const handleEditSize = useCallback(async () => {
    const tamahosAreCorrect = tamanhos.some((tamanho: any) => tamanho.active);

    if (!tamahosAreCorrect) {
      addToast({
        type: 'error',
        title: 'Algo deu errado.',
        description: 'Pelo menos um tamanho deve estar ativo',
      });

      return;
    }

    try {
      addToast({
        type: 'info',
        title: 'Aguarde!',
        description: 'Os tamanhos estão sendo editados',
      });

      await SizesService.updateSizes(
        user.empresa_id,
        tamanhos.map((tamanho) => ({
          id: tamanho.id,
          name: tamanho.name,
          order: tamanho.order,
          active: tamanho.active,
        })),
      );

      addToast({
        type: 'success',
        title: 'Sucesso!',
      });
    } catch (error) {
      const { message } = (error as any).response.data;

      addToast({
        type: 'error',
        title: 'Algo deu errado.',
        description: message,
      });
    }
  }, [user.empresa_id, tamanhos, addToast]);

  const handleEditColor = useCallback(async () => {
    const coresAreCorrect = cores.some((cor: any) => cor.active);

    if (!coresAreCorrect) {
      addToast({
        type: 'error',
        title: 'Algo deu errado.',
        description: 'Pelo menos uma cor deve estar ativa',
      });

      return;
    }

    try {
      addToast({
        type: 'info',
        title: 'Aguarde!',
        description: 'As cores estão sendo editadas',
      });

      await ColorsService.updateColors(
        user.empresa_id,
        cores.map((cor) => ({
          id: cor.id,
          name: cor.name,
          hex: cor.hex,
          order: cor.order,
          active: cor.active,
        })),
      );

      addToast({
        type: 'success',
        title: 'Sucesso!',
      });
    } catch (error) {
      const { message } = (error as any)?.response?.data;

      addToast({
        type: 'error',
        title: 'Algo deu errado.',
        description: message,
      });
    }
  }, [user.empresa_id, cores, addToast]);

  const handleDeleteTamanho = useCallback(
    async (id: number) => {
      setSelectedTamanho(undefined);

      if (tamanhos.length > 1) {
        setTamanhos((oldState) =>
          oldState.filter((tamanho) => tamanho.id !== id),
        );

        await SizesService.deleteSize(user.empresa_id, id);
      } else {
        addToast({
          title: 'Ocorreu um erro!',
          type: 'error',
          description: 'É obrigatório ter pelo menos um tamanho!',
        });
      }
    },
    [user.empresa_id, tamanhos, addToast],
  );

  const handleDeleteCor = useCallback(
    async (id: number) => {
      setSelectedCor(undefined);

      if (cores.length > 1) {
        setCores((oldState) => oldState.filter((cor) => cor.id !== id));

        await ColorsService.deleteColor(user.empresa_id, id);
      } else {
        addToast({
          title: 'Ocorreu um erro!',
          type: 'error',
          description: 'É obrigatório ter pelo menos uma cor!',
        });
      }
    },
    [user.empresa_id, cores, addToast],
  );

  return (
    <div className={classes_root.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="config_tabs"
        >
          <Tab label="Cores" {...a11yProps(0)} />
          <Tab label="Tamanhos" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={tab} index={0}>
        <Wrapper style={{ paddingLeft: 50, paddingRight: 50 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PageTitle>Cores</PageTitle>
              <InformativeSpan>
                Indique aqui quais as cores que seus produtos do tipo grade
                poderão ter.
              </InformativeSpan>
              <Grid container>
                <Header>
                  <div>
                    <p>Nome</p>
                  </div>
                  <div>
                    <p>Cor</p>
                  </div>
                </Header>
                <Grid container>
                  {cores
                    .sort((a: any, b: any) => a.order - b.order)
                    .map((cor) => (
                      <TamanhoItem key={cor.id}>
                        <div className="container__input">
                          <TamanhoInput
                            type="text"
                            defaultValue={cor.name}
                            placeholder="Nome"
                            onChange={(event) =>
                              handleSetCorValue(
                                cor.id,
                                'name',
                                event.target.value,
                              )
                            }
                          />
                          <TamanhoInputColor
                            value={cor.hex}
                            type="color"
                            defaultValue={cor.hex}
                            placeholder="Cor"
                            onChange={(event) =>
                              handleSetCorValue(
                                cor.id,
                                'hex',
                                event.target.value,
                              )
                            }
                          />
                        </div>
                        <div className="container__input">
                          <Grid item style={{ width: 120 }}>
                            <div
                              style={{
                                margin: 0,
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-end',
                                height: 'inherit',
                              }}
                            >
                              <div
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                              >
                                <StatusSaleButton
                                  type="button"
                                  isPaused={cor.active}
                                  className="paused"
                                  onClick={() =>
                                    handleSetCorValue(cor.id, 'active', false)
                                  }
                                >
                                  Inativo
                                </StatusSaleButton>

                                <StatusSaleButton
                                  type="button"
                                  isPaused={!cor.active}
                                  className="activated"
                                  onClick={() =>
                                    handleSetCorValue(cor.id, 'active', true)
                                  }
                                >
                                  Ativo
                                </StatusSaleButton>
                              </div>
                            </div>
                          </Grid>
                          <DeleteTamanhoButton
                            onClick={() => setSelectedCor(cor)}
                          >
                            <FiTrash2 size={18} />
                          </DeleteTamanhoButton>
                        </div>
                      </TamanhoItem>
                    ))}
                </Grid>
                <div>
                  <NewTamanhoButton onClick={handleCreateColor}>
                    <FiPlus size={15} />
                    Nova cor
                  </NewTamanhoButton>
                </div>
                <Grid item xs={12}>
                  <Grid container justify="center">
                    <Grid item lg={4} md={6} xs={12}>
                      <ButtonStyled type="button" onClick={handleEditColor}>
                        Salvar
                      </ButtonStyled>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            className={classes.modal}
            open={selectedCor}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={selectedCor}>
              <ModalWrapper>
                <div className="header">
                  <h1>Atenção</h1>

                  <button
                    type="button"
                    onClick={() => setSelectedCor(undefined)}
                  >
                    <RiCloseLine size={30} />
                  </button>
                </div>

                <div className="description">
                  <p>
                    Ao confirmar, todos os produtos que estão relacionados a
                    esta cor também serão excluídos.
                  </p>
                  <br />
                  <span>Deseja excluir a cor {selectedCor?.name}?</span>
                </div>

                <div className="btnActions">
                  <button
                    type="button"
                    className="confirm"
                    onClick={() => handleDeleteCor(selectedCor?.id)}
                  >
                    Confirmar
                  </button>

                  <button
                    type="button"
                    className="cancel"
                    onClick={() => setSelectedCor(undefined)}
                  >
                    Cancelar
                  </button>
                </div>
              </ModalWrapper>
            </Fade>
          </Modal>
        </Wrapper>
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <Wrapper style={{ paddingLeft: 50, paddingRight: 50 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PageTitle>Tamanhos</PageTitle>
              <InformativeSpan>
                Indique aqui quais os tamanhos que seus produtos do tipo grade
                poderão ter.
              </InformativeSpan>
              <Grid container>
                <Grid container>
                  <Grid item xs={2}>
                    <p>Nome</p>
                  </Grid>
                </Grid>
                <Grid container>
                  {tamanhos
                    .sort((a: any, b: any) => a.order - b.order)
                    .map((tamanho) => (
                      <TamanhoItem key={tamanho.id}>
                        <div className="container__input">
                          <TamanhoInput
                            type="text"
                            defaultValue={tamanho.name}
                            placeholder="Nome"
                            onChange={(event) =>
                              handleSetTamanhoValue(
                                tamanho.id,
                                'name',
                                event.target.value,
                              )
                            }
                          />
                        </div>
                        <div className="container__input">
                          <div
                            style={{
                              margin: 0,
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-end',
                              height: 'inherit',
                            }}
                          >
                            <div
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                            >
                              <StatusSaleButton
                                type="button"
                                isPaused={tamanho.active}
                                className="paused"
                                onClick={() =>
                                  handleSetTamanhoValue(
                                    tamanho.id,
                                    'active',
                                    false,
                                  )
                                }
                              >
                                Inativo
                              </StatusSaleButton>

                              <StatusSaleButton
                                type="button"
                                isPaused={!tamanho.active}
                                className="activated"
                                onClick={() =>
                                  handleSetTamanhoValue(
                                    tamanho.id,
                                    'active',
                                    true,
                                  )
                                }
                              >
                                Ativo
                              </StatusSaleButton>
                            </div>
                          </div>
                          <DeleteTamanhoButton
                            onClick={() => setSelectedTamanho(tamanho)}
                          >
                            <FiTrash2 size={18} />
                          </DeleteTamanhoButton>
                        </div>
                      </TamanhoItem>
                    ))}
                </Grid>
                <Grid item xs={3}>
                  <NewTamanhoButton onClick={handleCreateSize}>
                    <FiPlus size={15} />
                    Novo tamanho
                  </NewTamanhoButton>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justify="center">
                    <Grid item lg={4} md={6} xs={12}>
                      <ButtonStyled type="button" onClick={handleEditSize}>
                        Salvar
                      </ButtonStyled>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            className={classes.modal}
            open={selectedTamanho}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={selectedTamanho}>
              <ModalWrapper>
                <div className="header">
                  <h1>Atenção</h1>

                  <button
                    type="button"
                    onClick={() => setSelectedTamanho(undefined)}
                  >
                    <RiCloseLine size={30} />
                  </button>
                </div>

                <div className="description">
                  <p>
                    Ao confirmar, todos os produtos que estão relacionados a
                    este tamanho também serão excluídos.
                  </p>
                  <br />
                  <span>Deseja excluir o tamanho {selectedTamanho?.name}?</span>
                </div>

                <div className="btnActions">
                  <button
                    type="button"
                    className="confirm"
                    onClick={() => handleDeleteTamanho(selectedTamanho?.id)}
                  >
                    Confirmar
                  </button>

                  <button
                    type="button"
                    className="cancel"
                    onClick={() => setSelectedTamanho(undefined)}
                  >
                    Cancelar
                  </button>
                </div>
              </ModalWrapper>
            </Fade>
          </Modal>
        </Wrapper>
      </TabPanel>
    </div>
  );
};

export default Grade;
